import { Shape, ShapeOptions } from "../Shape";
import { SVGParsedPathData } from "../../../svg/";
import { YZCanvasContext } from "../canvas";

export class FoxShape extends Shape {
  constructor(options?: ShapeOptions) {
    super(options);
  }

  protected cloneShape(): FoxShape {
    const shape = new FoxShape({
      ...super.getBaseOptions()
    });
    return shape;
  }

  public toSVGPathData(): SVGParsedPathData[] {
    return [
      ["m", 4, 24],
      ["l", 4, -8],
      ["l", 6, -6],
      ["l", 1, -10],
      ["l", -6, -10],
      ["l", -7, 10],
      ["l", -4, 0],
      ["l", -7, -10],
      ["l", -6, 10],
      ["l", 1, 10],
      ["l", 6, 6],
      ["l", 4, 8],
      ["z"]
    ];
  }

  public toCanvasContext(ctx: YZCanvasContext) {
    ctx.beginPath();
    ctx.moveTo(4, 24);
    ctx.lineTo(8, 16);
    ctx.lineTo(14, 10);
    ctx.lineTo(15, 0);
    ctx.lineTo(9, -10);
    ctx.lineTo(2, 0);
    ctx.lineTo(-2, 0);
    ctx.lineTo(-9, -10);
    ctx.lineTo(-15, 0);
    ctx.lineTo(-14, 10);
    ctx.lineTo(-8, 16);
    ctx.lineTo(-4, 24);
    ctx.closePath();
  }
}

export default FoxShape;
